import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';
import { api } from 'bxcommon/store/api';

import userReducer from 'bxcommon/store/slices/user.slice';
import toasterReducer from 'bxcommon/store/slices/toaster.slice';
import resourcesReducer from 'bxcommon/store/slices/resources.slice';
import requestMetaReducer from 'bxcommon/store/slices/requestMeta.slice';
import listReducer from 'bxcommon/store/slices/list.slice';
import amendmentsReducer from 'bxcommon/store/slices/amendments.slice';
import requestReducer from './slices/request.slice';
import selectedUserGroupReducer from './slices/selectedUserGroup.slice';

// Import endpoints to ensure they are injected
import 'bxcommon/store/endpoints/resources.endpoints';
import 'bxcommon/store/endpoints/user.endpoints';
import './endpoints/prospectus.endpoints';

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    user: userReducer,
    toasts: toasterReducer,
    resources: resourcesReducer,
    requestMeta: requestMetaReducer,
    list: listReducer,
    amendments: amendmentsReducer,
    request: requestReducer,
    selectedUserGroup: selectedUserGroupReducer,
  },
  middleware: (getDefaultMiddleware) => {
    const mw = getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware);
    if (!import.meta.env.PROD) {
      mw.push(logger);
    }
    return mw;
  },
  devTools: !import.meta.env.PROD ? { trace: true, traceLimit: 25 } : false,
});

export default store;
